var logError = require('./error');
var resourceHelpers = require('./resourceHelpers.js')

var StaticDocLoader = function(root, dataManager, config) {
    this.root = root;
    this.dataManager = dataManager;
    this.config = config;
};
module.exports = StaticDocLoader;

StaticDocLoader.prototype.openDocument = function(doc_options, nodesToSkip) {
    var self = this;

    if (doc_options.isConversionService) {
        return self.readStaticDocForConversion(doc_options)
    }

    this.readOnly = doc_options.readOnly;

    var assetPromise = Promise.resolve();
    if (!doc_options.id || doc_options.id.length === 0) {
        if (doc_options.creationAllowed){
            assetPromise = assetPromise.then(function() {
                return self.createNewResource(doc_options);
            });
        } else {
            var err = new Error("Not allowed to create a new asset");
            logError("ShareJsDocLoader", err, logError.criticality.BLOCKING, "Not allowed to create a new asset");
            return Promise.reject(err);
        }
    } else {
        assetPromise = assetPromise.then(function() {
            return self.dataManager.getResource(doc_options.assetType, doc_options.id);
        });
    }


    assetPromise = this.redirectToReadOnlyModeIfNoWriteAccess(assetPromise)
    .then(function(resource){
    	self.root.asset = resource;
	 	var savepoint = resourceHelpers.getMostRecentSavepoint(resource, ["savedSnapshot", "draft"]);
	 	if(savepoint == -1){
            if(resource.sharejs_id && !self.readOnly){
                // if there is a doc, migrate it.
                // after migration there will be a savpoint, so we won't end up here again.
                // don't migrate if read-only, the CS may deny you.
                return self.getMigratedCollabDoc(doc_options.assetType, doc_options.id, self.config.datamodel.datamodel_version, nodesToSkip);
            } else {
                return self.makeNewCollabDoc(doc_options, resource.forked_from);
            }

	    } else if(!doc_options.version){
             // if version is not provided (but does exist) then open the most recent version

            let isDraft = savepoint.type == "draft";

            if(self.readOnly){
                let lastVersion = resourceHelpers.getMostRecentSavepoint(resource, ["savedSnapshot"]);

                if(lastVersion == -1){
                    // we have a draft but no snapshot (ie fork) and are in read only with no version.
                    // we can't show the current draft, that would reveal too much data for read only mode.
                    // we can just show empty collab doc tho, since saving can't happen in read only
                    return self.makeNewCollabDoc(doc_options);

                } else {
                    return self.getSnapshot(doc_options.assetType, doc_options.id, lastVersion.version, self.config.datamodel.datamodel_version, nodesToSkip)
                }


            } else if(!isDraft && resourceHelpers.shouldMigrateCollabDoc(resource)){
                return self.getMigratedCollabDoc(doc_options.assetType, doc_options.id, self.config.datamodel.datamodel_version, nodesToSkip);

            } else {
                return self.getCollabDoc(doc_options.assetType, doc_options.id, self.config.datamodel.datamodel_version, nodesToSkip, isDraft);
            }
         } else if(!self.readOnly){

            // if version is provided we must be read only
            self.redirectToReadOnly();

		} else {
			// version is provided, so open the version given.
            return self.getSnapshot(doc_options.assetType, doc_options.id, doc_options.version, self.config.datamodel.datamodel_version, nodesToSkip)
		}
	});


    return assetPromise;
};

StaticDocLoader.prototype.getSnapshot = function(type, id, version, dm_v, nodesToSkip){
	var self = this;
	return self.dataManager.getResourceSnapshot(type, id, version, dm_v)
    .then(function(json){
    	self.root.header = json["header"];   // save the header directly in the root: header is not observable and read-only
		  var data = self.root.dejsonify(json["body"], nodesToSkip);   // dejsonify the body in this root as an observable and shared datamodel
		  self.root.attachData(data);
    })
}


StaticDocLoader.prototype.getCollabDoc = function(type, id, dm_v, nodesToSkip, isDraft){
    var self = this;
    return self.dataManager.getResourceColabDoc(type, id, dm_v)
    .then(function(json){
        self.root.header = json["header"];   // save the header directly in the root: header is not observable and read-only
        var data = self.root.dejsonify(json["body"], nodesToSkip);   // dejsonify the body in this root as an observable and shared datamodel
        self.root.attachData(data);
        if(isDraft) self.root.wasChanged();
    })
}


StaticDocLoader.prototype.getMigratedCollabDoc = function(type, id, dm_v, nodesToSkip){
    var self = this;
    return self.dataManager.migrateCollabDocToDraft(type, id, dm_v)
    .then(function(json){
        self.root.header = json["header"];   // save the header directly in the root: header is not observable and read-only
        var data = self.root.dejsonify(json["body"], nodesToSkip);   // dejsonify the body in this root as an observable and shared datamodel
        self.root.attachData(data);
        self.root.wasChanged();
    })
}

StaticDocLoader.prototype.makeNewCollabDoc = function(doc_options){
	var self = this;
	return self.dataManager.getEmptyColabDoc(doc_options.assetType, doc_options.id, self.config.datamodel.datamodel_version)
	.then(function(res){
		self.root.header = {
	        "assetId" : res["header"]["assetId"],
	        "assetType" : res["header"]["assetType"],
	        "datamodel_version": res["header"]["datamodel_version"]
	    };
        var data = new doc_options.dataClass(true);
        self.root.attachData(data);
	})
}

StaticDocLoader.prototype.redirectToReadOnly = function(){
	var newMode = 2;
    var new_ = "";
    var modeSet = false;
    window.location.search.substr(1).split("&").forEach(function(part) {
        var item = part.split("=");
        if(item.length != 2) return;
        if(item[0] == "mode") {
            item[1] = newMode;
            modeSet = true;
        }
        new_ += `&${item[0]}=${item[1]}`;
    });
    if(!modeSet)
        new_ += `&mode=${newMode}`;
    window.location.search = new_;

    // easiest thing to do is to throw a trivial error.  That will stop the rest of the controllers from loading,
    // and print to the console (instead of letting all the future errors happen from a null reource)
    let err = new Error("no write access");
    logError("Document loader", err, logError.criticality.TRIVIAL, "no write access- must be read-only", true, null);
    throw err;
}

StaticDocLoader.prototype.redirectToReadOnlyModeIfNoWriteAccess = function(assetPromise) {
    var self = this;
    return assetPromise.then((asset) => {
        if(asset.hasUserWritePermissions()
            || self.readOnly) {
            return asset;
        } else {
            self.redirectToReadOnly();
        }
    });
};

StaticDocLoader.prototype.createNewResource = function(doc_options) {
    var self = this;
    var assetType = doc_options.assetType;
    var capitalizedAssetType = assetType.charAt(0).toUpperCase() + assetType.slice(1);
    var emptyResource = {
        "name": "New "+capitalizedAssetType,
        "description": "",
        "tags": [],
        "score": 0,
        "hub": doc_options.hub
    };
    if(doc_options.assetType == "library"){ emptyResource['assets'] = []; } // TODO: this doesn't belong here!
    return self.dataManager.createResource(emptyResource, doc_options.assetType)
    .then(function(res) {
        doc_options.id = res["id"];
        window.history.pushState(null, "", "?assetid="+res["id"]); //Change url to include assetid
        return self.dataManager.getResource(doc_options.assetType, doc_options.id); // TODO:no need to get just created resource, createResource should return created resource
    });
};

StaticDocLoader.prototype.afterLoad = function() {
};

StaticDocLoader.prototype.readStaticDocForConversion = function(doc_options)
{
    var self = this;
    return new Promise(function(resolve, reject) {
        var json = doc_options.asset;
        self.root.header = json["header"];   // save the header directly in the root: header is not observable and read-only
        var data = self.root.dejsonify(json["body"]);   // dejsonify the body in this root as an observable and shared datamodel
        self.root.attachData(data);
        resolve();
    });
}
